import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import type { IResourceDatabaseField } from '@/api/types';

import { ButtonBase, TableCard } from '@/components/common';
import { otherColors } from '@/styles/colors';
import { CheckBlue, DeleteBlue, PenWhite } from '@/assets/icons';
import { media } from '@/styles/theme';

interface IProps {
  items: IResourceDatabaseField[];
  className?: string;
}

const ResourceDatabaseFieldsTableMobile = ({ items, className }: IProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <TableCard className={className}>
      {items.map((item, id) => (
        <TableCard.CardTableRowsWrapper
          key={id}
          isCollapsable={true}
          firstBgColor="#f3f4f6"
          secondBgColor="#fff"
          activeBorderColor="#0087dd"
        >
          <TableCard.TableRow firstBgColor="#f3f4f6" secondBgColor="#fff">
            <TableCard.Cell width="60%">
              <TableCard.CellHeader>{t`resources.foldersList.headerName`}</TableCard.CellHeader>
              <TableCard.CellValue>{item.name}</TableCard.CellValue>
            </TableCard.Cell>
            <TableCard.Cell width="40%">
              <TableCard.CellHeader>{t`resources.foldersList.headerType`}</TableCard.CellHeader>
              <TableCard.CellValue>{item.type}</TableCard.CellValue>
            </TableCard.Cell>
          </TableCard.TableRow>
          <TableCard.TableExpandedRow>
            <TableCard.ExpandedRowContainer>
              <TableCard.Cell width="33%">
                <TableCard.CellHeader>{t`resources.foldersList.headerSearchable`}</TableCard.CellHeader>
                <TableCard.CellValue>{item.searchable && <IconCell src={CheckBlue} />}</TableCard.CellValue>
              </TableCard.Cell>
              <TableCard.Cell width="33%">
                <TableCard.CellHeader>{t`resources.foldersList.headerRequired`}</TableCard.CellHeader>
                <TableCard.CellValue>{item.required && <IconCell src={CheckBlue} />}</TableCard.CellValue>
              </TableCard.Cell>
              <TableCard.Cell width="33%">
                <TableCard.CellHeader>{t`resources.foldersList.headerUnique`}</TableCard.CellHeader>
                <TableCard.CellValue>{item.unique && <IconCell src={CheckBlue} />}</TableCard.CellValue>
              </TableCard.Cell>
            </TableCard.ExpandedRowContainer>
            <TableCard.ExpandedRowContainer>
              <TableCard.Cell width="100%">
                <ButtonContainer>
                  {/* TODO: Add option callbacks */}
                  <EditButton onClick={() => ''} icon={PenWhite}>
                    {t`common.btnEdit`}
                  </EditButton>
                  <DeleteButton onClick={() => ''} icon={DeleteBlue}>
                    {t`common.btnDelete`}
                  </DeleteButton>
                </ButtonContainer>
              </TableCard.Cell>
            </TableCard.ExpandedRowContainer>
          </TableCard.TableExpandedRow>
        </TableCard.CardTableRowsWrapper>
      ))}
    </TableCard>
  );
};

export { ResourceDatabaseFieldsTableMobile };

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 8px;

  button {
    flex: 1;
  }
`;

const EditButton = styled(ButtonBase)`
  background-color: ${otherColors.lxc.blue} !important;
  color: #fff !important;
  height: 30px;
  border: none;
  padding: 0 12px;
`;

const DeleteButton = styled(ButtonBase)`
  background-color: #fff !important;
  color: ${otherColors.lxc.blue} !important;
  height: 30px;
  border: 1px solid ${otherColors.lxc.blue};
  padding: 0 12px;
`;

const IconCell = styled.img`
  max-height: 16px;

  ${media.tablet} {
    width: 100%;
  }
`;
